import React, {useContext} from 'react'
import {lotContext} from "../../auction-lots-listing/components/lots-list-item/lots-list-item";

import {deleteChangeLot, setChangeLot, toggleModal} from "../../../redux/modals/modal-inline-mod-check/actionModal";
import {useDispatch} from "react-redux";
import useIsLotSelected from "../../auction-lots-listing/components/lots-list-item/useIsLotSelected";

const CheckBox = React.memo(() => {
    const dispatch = useDispatch();
    const {lotData: {auction_id}} = useContext(lotContext);
    const selected = useIsLotSelected(auction_id);

    const onToggleLot = () => {
        if (!selected) {
            dispatch(setChangeLot(auction_id));
            dispatch(toggleModal(true));
        } else {
            dispatch(deleteChangeLot(auction_id));
        }
    };

    return (
        <input 
            checked={selected}
            className="form-check-input"
            id={`lot_${auction_id}_title`}
            type="checkbox"
            onChange={onToggleLot}
            data-action
        />
    );
});

export default CheckBox;